<div class="order-ticket-cont">
  <app-qr-data-card
    [header]="getHeaderText()"
    [footer]="env.platform"
    [qrData]="orderTicket.uuid"
    [logo]="env.logoAsset"
    [data]="orderTicket.ticketNumber"
    [loggedUser]="loggedUser"
    [isBackSide]="false"
    [allowFlip]="false"
    [brandColors]="false"
  ></app-qr-data-card>

  <swiper-container
    appSwiper
    #swiperElement
    [config]="swiperActionsConfig"
    #swiperRef
    class="ticket-actions-swiper"
  >
    @for (ticketAction of TicketAction.getAllTicketActions(); track $index) {
      @if (
        ticketAction !== TicketAction.REFUND ||
        (event?.ticketRefundPolicy?.refundAllowed && !areTicketsFree())
      ) {
        <swiper-slide>
          <app-ticket-action
            [label]="TicketAction.getDisplayName(ticketAction)"
            [icon]="TicketAction.getIcon(ticketAction)"
            (click)="executeAction(ticketAction)"
          />
        </swiper-slide>
      }
    }
  </swiper-container>

  <div class="owner-cont">
    <div class="owner-header">
      {{ "APP.TICKETS_DASHBOARD.OWNER" | translate }}
    </div>
    <app-ticket-order-ticket-owner-card
      [ticket]="orderTicket"
      (forwardTicket)="forwardTicket()"
    />
  </div>
</div>
